
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"POSMetaDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Products_POSMetaData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeBatchTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canonicalBrandId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalBrandName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalCategoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalPackageId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalImgUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalLabResultUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalProductTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canonicalSKU"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalStrainId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalVendorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeBatchTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canonicalBrandId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalBrandName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalCategoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalEffectivePotencyMg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalPackageId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalImgUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalLabResultUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalSKU"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalProductTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canonicalStrainId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalVendorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kioskQuantityAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packageQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recEquivalent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"standardEquivalent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrationID"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":996}};
    doc.loc.source = {"body":"fragment POSMetaDataFragment on Products_POSMetaData {\n  activeBatchTags {\n    tagId\n  }\n  canonicalBrandId\n  canonicalBrandName\n  canonicalCategory\n  canonicalCategoryId\n  canonicalID\n  canonicalPackageId\n  canonicalImgUrl\n  canonicalLabResultUrl\n  canonicalName\n  canonicalProductTags {\n    tagId\n  }\n  canonicalSKU\n  canonicalStrainId\n  canonicalVendorId\n  children {\n    activeBatchTags {\n      tagId\n    }\n    canonicalBrandId\n    canonicalBrandName\n    canonicalCategory\n    canonicalCategoryId\n    canonicalEffectivePotencyMg\n    canonicalID\n    canonicalPackageId\n    canonicalImgUrl\n    canonicalLabResultUrl\n    canonicalName\n    canonicalSKU\n    canonicalProductTags {\n      tagId\n    }\n    canonicalStrainId\n    canonicalVendorId\n    kioskQuantityAvailable\n    medPrice\n    option\n    packageQuantity\n    price\n    quantity\n    quantityAvailable\n    recEquivalent {\n      value\n      unit\n    }\n    recPrice\n    standardEquivalent {\n      value\n      unit\n    }\n  }\n  integrationID\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["POSMetaDataFragment"] = oneQuery(doc, "POSMetaDataFragment");
        
